import React, { useRef, useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setInputTypeAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setKeypadAction } from "../../../../redux/answeringQuestions/keypad";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";

const KeyClicker = ( props ) => {

  const touchDelayTimer = useRef( 0 );
  const moreKeyName = useRef( '' );
  const moreKeyIndex = useRef( '' );

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setInputType = payload => { dispatch( setInputTypeAction( payload ) ) };
  const setKeypad = payload => { dispatch( setKeypadAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  useEffect( () => {
    if ( TYPE.DEVICE.PHONE === deviceInfo.type ) {
      document.addEventListener( 'touchmove', selectMoreKey );
      document.addEventListener( 'touchend', hideMoreKey );
      return () => {
        document.removeEventListener( 'touchmove', selectMoreKey );
        document.removeEventListener( 'touchend', hideMoreKey );
      };
    }
  }, [] );

  const setTabIndex = ( event ) => {
    setKeypad( { tabIndex : event.target.getAttribute( 'index' ) } );
    startCount();
  };

  const startCount = () => {
    setInputType( TYPE.INPUT.KEYPAD );
    props.onCount();
  };

  const setAnswerKey = ( event ) => {
    setAnswerEditor( {
      answerKey : `${ event.currentTarget.getAttribute( 'latex' ) }?${ Date.now() }`,
      cursor : event.currentTarget.getAttribute( 'cursor' )
    } );
    startCount();
  };

  const startTouch = ( event ) => {
    touchDelayTimer.current = setTimeout( showMoreKey, 500, event.currentTarget.name );
    startCount();
  };

  const showMoreKey = ( name ) => {
    moreKeyName.current = name;
    setKeypad( { moreKeyName : name } );
  };

  const selectMoreKey = ( event ) => {
    const changedTouches = event.changedTouches[ 0 ];
    const target = document.elementFromPoint( changedTouches.clientX, changedTouches.clientY );
    const changedMoreKeyIndex = target?.parentNode.getAttribute( 'more-key-index' );
    if ( moreKeyIndex.current !== changedMoreKeyIndex ) {
      moreKeyIndex.current = changedMoreKeyIndex;
      setKeypad( { moreKeyIndex : changedMoreKeyIndex } );
    }
  };

  const hideMoreKey = ( event ) => {
    const changedTouches = event.changedTouches[ 0 ];
    const target = document.elementFromPoint( changedTouches.clientX, changedTouches.clientY );
    const moreKeyLatex = target?.parentNode.getAttribute( 'more-key-latex' );
    clearTimeout( touchDelayTimer.current );
    moreKeyLatex && setAnswerEditor( { answerKey : `${ moreKeyLatex }?${ Date.now() }` } );
    moreKeyName.current = '';
    moreKeyIndex.current = '';
    setKeypad( {
      moreKeyName : '',
      moreKeyIndex : ''
    } );
  };

  const showEditableViewerAndSetAnswerKey = ( event ) => {
    ! answerEditor.isShow && setAnswerEditor( { isShow : true } );
    setAnswerKey( event );
  };

  return cloneElement( props.children || <Fragment />, {
    onTab : setTabIndex,
    onKey : setAnswerKey,
    onTouchStart : startTouch,
    onEditableViewer : showEditableViewerAndSetAnswerKey
  } );

};

export default KeyClicker;
